/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTapLogs.vue?vue&type=template&id=2f45bc10&scoped=true"
import script from "./popAirdropTapLogs.vue?vue&type=script&lang=js"
export * from "./popAirdropTapLogs.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTapLogs.vue?vue&type=style&index=0&id=2f45bc10&prod&lang=scss&scoped=true"
import style1 from "./popAirdropTapLogs.vue?vue&type=style&index=1&id=2f45bc10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45bc10",
  null
  
)

export default component.exports